// Adinivois_UI/src/app/guards/onboarding.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FirmService } from './firm.service';

export const onboardingGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const firmService = inject(FirmService);

  const firm = await firstValueFrom(firmService.subject);
  if (firm?.onboarded) {
    return router.parseUrl('/dashboard/members/Dashboard');
  }
  return true;
};
